import { type Stats } from 'src/types'

// stats aglomerate all player game data used for combat and stat related things

const defaultStats: Stats = {
  // the naked version
  player: {
    player_lvl: 1,
    player_lvl_exp: 0,
    player_hp: 16,
    player_hp_max: 16,
    player_ap: 10,
    player_ap_max: 10,
    player_str: 1,
    player_str_exp: 0,
    player_dex: 1,
    player_dex_exp: 0,
    player_vit: 1,
    player_vit_exp: 0,
    player_karma: 0
  },
  // the equipped total
  equipped: {
    bag_slots: 2,
    bag_slots_max: 20,
    kg: 0,
    kg_max: 10,
    attack_bonus: 0,
    armor_bonus: 0,
    player_str: 0,
    player_dex: 0,
    player_vit: 0,
    player_hp_max: 0,
    player_ap_max: 0,
    light_radius: 0
  },
  // combines the former 2
  total: {
    player_lvl: 1,
    player_lvl_exp: 0,
    player_hp: 16,
    player_hp_max: 16,
    player_ap: 10,
    player_ap_max: 10,
    player_str: 1,
    player_str_exp: 0,
    player_dex: 1,
    player_dex_exp: 0,
    player_vit: 1,
    player_vit_exp: 0,
    player_karma: 0,
    bag_slots: 2,
    bag_slots_max: 20,
    kg: 0,
    kg_max: 10,
    attack_bonus: 0,
    armor_bonus: 0,
    light_radius: 0
  }
}

export {
  defaultStats
}
